<div class="actions" *ngIf="approvalSteps && approvalSteps.length">
  <div class="boxItem main-box start"><span>Requester</span></div>
  <ng-container *ngFor="let approvalStep of approvalSteps">
    <div class="arrow"><em class="icon-down-arrow ml-2 float-right"></em></div>
    <div class="boxItem condition" [ngClass]="approvalStep.approvalStatus.toLowerCase()">
      <div class="head"></div>
      <div class="body">
        <div class="d-md-flex flex-fill justify-content-end align-items-end">
          <span class="status mr-auto ng-star-inserted">
            {{ checkAutoApprove | pureFn: approvalStep : approvalStatusEnum }}
            {{ 'APPROVAL_WORKFLOW.APPROVAL_STATUS.' + approvalStep.approvalStatus | translate }}
          </span>
          <span class="date">{{
            getApproveOrRejectDate | pureFn: approvalStep | amFromUtc | amLocal | dateDisplay: dateTimeDisplay : ''
          }}</span>
        </div>
        <div class="title d-md-flex flex-fill justify-content-end">
          <span class="mr-auto ng-star-inserted">{{ approvalStep.name }}</span>
        </div>
        <div class="details">
          <ng-container *ngIf="!approvalStep.autoApprove; else autoApprove">
            <div class="detail-label mb-1">Approver:</div>
            <ng-container *ngFor="let approver of approvalStep.approvers">
              <span class="d-flex mb-1"
                ><em *ngIf="approver.approve === true" class="icon-approved-workflow mr-1"></em>
                <em *ngIf="approver.approve === false" class="icon-rejected-workflow mr-1"></em>
                <div class="detail-value" [ngClass]="{ active: approver.approve !== null }">
                  {{ approver.firstName }} {{ approver.lastName }}
                </div></span
              >
            </ng-container>
          </ng-container>
          <ng-template #autoApprove>
            <div class="detail-label mb-1">Auto Approve Amount:</div>
            <div class="detail-label">{{ approvalStep.autoApprovalLimit | numberFormatDisplay: 2 }}</div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="arrow"><em class="icon-down-arrow ml-2 float-right"></em></div>
  <div class="boxItem main-box end" [ngClass]="{ complete: isFlowComplete }"><span>Completed</span></div>
</div>
